import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { FieldArray, useField } from "formik";
import InputErrorMessage from "../InputErrorMessage/InputErrorMessage";
import PropTypes from "prop-types";
import * as styles from "./FormikHelper.module.scss";

const FieldArrayHelper = (props) => {
	const {
		name,
		components,
		renderGrid = false,
		renderFlex = false,
		itemsProRow = 3,
		instantRequired = false,
	} = props;
	const [error, setError] = useState({
		hasError: false,
		errorMessage: "",
	});
	const className = classNames({
		[props.className]: !!props.className,
		[styles.required]: props.required,
	});

	const rowClassName = classNames(
		{
			[styles["grid-view"]]: renderGrid,
			[styles["flex-view"]]: renderFlex,
			// ["mb-6"]: !renderGrid,
			[props.rowClassName]: !!props.rowClassName,
			[styles.required]: props.required,
			[styles["multiple-elements"]]: components?.length >= 3,
		},
		styles.row,
	);

	let rowProps = {
		className: rowClassName,
	};

	if (renderGrid) {
		rowProps.style = { gridTemplateColumns: `repeat(${itemsProRow}, 1fr)` };
	}

	const [, formikError] = useField(name);

	useEffect(() => {
		setError({
			hasError: instantRequired,
			errorMessage: instantRequired ? formikError.error : "",
		});
	}, [instantRequired, formikError.error]);

	return (
		<div className={className}>
			<div {...rowProps}>
				<FieldArray
					{...props}
					render={() => (
						<>
							{components.map((current) => {
								return React.cloneElement(
									current,
									Object.assign(
										{},
										{
											groupError: true,
											name: name, //current.props.name,
											errorCallback: (groupError) => {
												setError(groupError);
											},
										},
									),
								);
							})}
						</>
					)}
				/>
			</div>

			<InputErrorMessage show={error.hasError} msg={error.errorMessage} />
		</div>
	);
};

FieldArrayHelper.propTypes = {
	name: PropTypes.string.isRequired,
	components: PropTypes.array.isRequired,
	itemsProRow: PropTypes.number,
	rowClassName: PropTypes.string,
	renderGrid: PropTypes.bool,
	renderFlex: PropTypes.bool,
};

export default FieldArrayHelper;
